
export const getPermissionMenus = (menus, role, result = null) => {
  const res = result || []
  menus.forEach(menu => {
    if (!menu.meta?.roles || menu.meta?.roles?.includes(role)) {
      const { children, ...other } = menu
      if (children) {
        other.children = getPermissionMenus(children, role, [])
      }
      res.push(other)
    }
  })
  return res
}

// 根据状态返回色彩
export const getBadgeColor = (state) => {
  if (state === 'RUNNING_SUCCESS') return Xinnet.settings.badgeColor.success
  if (state === 'RUNNING_FAIL') return Xinnet.settings.badgeColor.error
  if (state === 'RUNNING') return Xinnet.settings.badgeColor.primary
  if (state === 'STOP') return Xinnet.settings.badgeColor.info
}

// 加入任务飞入效果
export const flyIn = (start) => {
  const action = (startConfig, endConfig, container = document.body) => {
    return new Promise((resolve) => {
      // 元素
      const body = container
      const flyRound = document.createElement('div')
      const flyChild = document.createElement('div')
      flyRound.appendChild(flyChild)
      body.appendChild(flyRound)

      // 位置信息
      const { top: startTop, left: startLeft } = startConfig
      const { top: endTop, left: endLeft } = endConfig

      // 动画样式
      requestAnimationFrame(() => {        
        flyRound.setAttribute('class', 'fly-round-task')
        flyRound.setAttribute('style', `
          transition: all .6s cubic-bezier(0, 0.74, 0.53, 1.09) 0s;
          position: absolute;
          top: ${startTop}px;
          left: ${startLeft}px;
          z-index: 2000`)
  
        flyChild.setAttribute('style', `
          width: 16px;
          height: 16px;
          border-radius: 50%;
          transition: all .6s ease 0s;
          background: #1677FF`)
        const flyTimer = setTimeout(() => {
          flyRound.style.transform = `translate3d(0, ${(endTop - startTop)}px, 0)`
          flyChild.style.transform = `translate3d(${(endLeft - startLeft)}px, 0, 0)`
          const removeTimer = setTimeout(() => {
            clearTimeout(flyTimer)
            clearTimeout(removeTimer)
            body.removeChild(flyRound)
            resolve(true)
          }, 600)
        }, 1)
      })
    })
  }
  
  const end = document.getElementById('taskMsg')
  if (start && end && start instanceof HTMLElement) {
    const startConfig = start.getBoundingClientRect()
    const endConfig = end.getBoundingClientRect()
    action(
      { top: startConfig.top, left: startConfig.left },
      { top: endConfig.top, left: endConfig.left },
    )
  }
}

// 域名格式校验+中文后缀
export const validateZhDomain = (val)=>{
  const regexp = /^(?:[a-zA-Z0-9\u4e00-\u9fff](?:[a-zA-Z0-9-\u4e00-\u9fff]{0,61}[a-zA-Z0-9\u4e00-\u9fff])?\.)+([a-zA-Z\u4e00-\u9fff]){2,}$/
  return regexp.test(val)
}

//容量转换
export function fileDiskSize(num, n){
	if (num == 0) return '0 B';
	let k = 1024; //设定基础容量大小
	let sizeStr = ['B','KB','MB','GB','TB','PB','EB','ZB','YB']; //容量单位
	let i = 0; //单位下标和次幂
	for(let l=0;l<8;l++){   //因为只有8个单位所以循环八次
    if(num / Math.pow(k, l) < 1){ //判断传入数值 除以 基础大小的次幂 是否小于1，这里小于1 就代表已经当前下标的单位已经不合适了所以跳出循环
		break; //小于1跳出循环
    }
    i = l; //不小于1的话这个单位就合适或者还要大于这个单位 接着循环
	}
     // 例： 900 / Math.pow(1024, 0)  1024的0 次幂 是1 所以只要输入的不小于1 这个最小单位就成立了；
     //     900 / Math.pow(1024, 1)  1024的1次幂 是1024  900/1024 < 1 所以跳出循环 下边的 i = l；就不会执行  所以 i = 0； sizeStr[0] = 'B';
     //     以此类推 直到循环结束 或 条件成立
    return (num / Math.pow(k, i)).toFixed(n ? n : 0) + ' ' + sizeStr[i];  //循环结束 或 条件成立 返回字符
 
}
